import { Checkbox, DatePicker, Form, Input, InputNumber, Select, TimePicker } from 'antd';
import Password from 'antd/lib/input/Password';
import TextArea from 'antd/lib/input/TextArea';
import styled from 'styled-components';

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 0;

  label {
    font-size: 12px;
    font-weight: 300;
    color: #737777;
  }

  .ant-form-item-label {
    padding-bottom: 4px;
  }
`;

export const StyledInput = styled(Input)`
  &&.ant-input {
    font-size: 14px !important;
    font-weight: 300;
    font-family: 'Barlow';
  }

  &&.ant-input-lg {
    height: 32px;
    font-size: 14px !important;
    font-weight: 300;
  }

  &::placeholder {
    font-size: 14px;
    font-weight: 300;
  }

  /* Target input inside input-group-wrapper (when addonAfter/addonBefore is used) */
  .ant-input {
    font-size: 14px !important;
    font-weight: 300;
  }

  .ant-input-lg {
    font-size: 14px !important;
    font-weight: 300;
  }

  &.ant-input-affix-wrapper-lg {
    padding: 3px 11px;
  }
`;

export const StyledPassword = styled(Password)`
  &&.ant-input-affix-wrapper {
    font-size: 14px !important;
    font-weight: 300;
  }

  &&.ant-input-affix-wrapper-lg {
    height: 32px;
  }

  input.ant-input {
    font-size: 14px !important;
    font-weight: 300;
  }

  input.ant-input::placeholder {
    font-size: 14px;
    font-weight: 300;
  }
`;

export const StyledInputNumber = styled(InputNumber)`
  width: 100%;
  input {
    font-size: 14px !important;
    font-weight: 300;
  }

  .ant-input-number-suffix {
    font-size: 14px;
  }

  &.ant-input-number-lg {
    height: 32px;

    input {
      height: 30px;
    }

    .ant-input-number-input-wrap .ant-input-number-input {
      height: 30px;
    }
  }
  .ant-input-number-lg {
    .ant-input-number-input-wrap .ant-input-number-input {
      height: 30px;
    }
  }

  &::placeholder {
    font-size: 14px;
    font-weight: 300;
  }
`;

export const StyledTextArea = styled(TextArea)`
  font-size: 14px !important;
  font-weight: 300;
  font-family: 'Barlow';

  &::placeholder {
    font-size: 14px;
    font-weight: 300;
  }
`;

export const StyledSelect = styled(Select)`
  &&.ant-select {
    font-size: 14px !important;
    font-weight: 300;
    font-family: 'Barlow';
  }

  &&.ant-select-lg {
    font-size: 14px !important;
    font-weight: 300;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    font-size: 14px !important;
    font-weight: 300;
  }

  /* showSearch overlays a full-width input; when closed it steals hover/cursor from the arrow */
  &&.ant-select-show-search:not(.ant-select-open) {
    cursor: pointer;

    .ant-select-selector,
    .ant-select-selection-item,
    .ant-select-selection-placeholder,
    .ant-select-arrow,
    .ant-select-suffix {
      cursor: pointer;
    }

    .ant-select-selection-search,
    .ant-select-selection-search-input {
      pointer-events: none;
      cursor: pointer;
    }

    .ant-select-arrow {
      z-index: 1;
    }
  }

  &&.ant-select-show-search.ant-select-open {
    .ant-select-selection-search,
    .ant-select-selection-search-input {
      pointer-events: auto;
      cursor: text;
    }
  }

  &.no-removable-options {
    .ant-select-selection-item-remove {
      display: none;
    }
  }

  &.ant-select-lg {
    height: 32px;

    .ant-select-selector {
      height: 32px !important;
      padding-inline-end: 32px !important;

      .ant-select-selection-item {
        line-height: 30px !important;
        display: flex;
        align-items: center;
      }

      .ant-select-selection-search {
        display: flex;
        align-items: center;
        height: 100%;
        right: 32px;
      }

      .ant-select-selection-search-input {
        height: 100% !important;
        line-height: 1 !important;
      }
    }
  }

  /* Multiple selection mode - tags alignment */
  &.ant-select-multiple.ant-select-lg {
    .ant-select-selector {
      padding: 3px 4px;

      .ant-select-selection-overflow {
        margin-top: -12px;
      }

      .ant-select-selection-item {
        height: 24px;
        line-height: 24px !important;
        margin: 0 4px 0 0;

        .ant-select-selection-item-content {
          line-height: 24px;
        }

        .ant-select-selection-item-remove {
          display: flex;
          align-items: center;
          line-height: 1;
        }
      }
    }
  }

  &.analytics-source.ant-select-multiple.ant-select-lg {
    --ant-select-height: 32px;
    --ant-select-multi-item-height: 24px;
    align-items: center;

    .ant-select-content {
      align-self: center;
    }

    .ant-select-selection-item {
      height: 24px;
      line-height: 22px;
      align-items: center;
    }

    .ant-select-placeholder {
      font-size: inherit;
    }
  }

  /* Activity log horizontal filter: compact 32px multi-select */
  &.activity-actions-select.ant-select-multiple.ant-select-lg {
    height: 32px !important;
    position: relative;

    .ant-select-arrow,
    .ant-select-suffix {
      position: absolute !important;
      inset-inline-end: 8px;
      top: 50%;
      transform: translateY(-50%);
      margin: 0 !important;
      height: auto;
      display: flex;
      align-items: center;
      pointer-events: none;
    }

    .ant-select-selector {
      height: 32px !important;
      padding: 0 24px 0 4px !important;
      display: flex;
      align-items: center;
      position: relative;

      .ant-select-selection-overflow {
        margin-top: 0 !important;
      }

      .ant-select-selection-placeholder {
        line-height: 30px !important;
        inset-inline-start: 4px;
      }
    }

    .ant-select-content,
    .ant-select-selection-overflow {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      align-self: center;
      flex: 1 1 auto;
      width: 100%;
      min-width: 0;
      max-width: 100%;
    }

    .ant-select-content-item,
    .ant-select-selection-overflow-item {
      display: flex;
      align-items: center;
      align-self: center;
      line-height: normal !important;
      flex: 0 0 auto;
    }

    .ant-select-selection-overflow-item-suffix,
    .ant-select-content-item-suffix {
      flex: 0 0 0 !important;
      width: 0 !important;
      min-width: 0 !important;
      margin: 0 !important;
      overflow: hidden;
      opacity: 0;
      pointer-events: none;
    }

    &.ant-select-open {
      .ant-select-selection-overflow-item-suffix,
      .ant-select-content-item-suffix {
        flex: 1 1 auto !important;
        width: auto !important;
        min-width: 4px !important;
        opacity: 1;
        pointer-events: auto;
      }
    }

    .ant-select-selection-item {
      height: 24px !important;
      line-height: 22px !important;
      margin: 0 !important;
      max-width: 100%;
      display: inline-flex !important;
      align-items: center !important;

      .ant-select-selection-item-content {
        line-height: 22px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .ant-select-selection-overflow-item-rest,
    .ant-select-content-item-rest {
      flex-shrink: 0;
      margin-left: 4px;

      .ant-select-selection-item {
        max-width: none !important;
        min-width: auto;
        margin: 0 !important;
        padding-inline: 6px !important;

        .ant-select-selection-item-content {
          overflow: visible !important;
          text-overflow: clip !important;
        }
      }
    }
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  font-size: 14px !important;
  font-weight: 300;

  &.ant-picker-large {
    height: 32px;

    input {
      font-size: 14px !important;
      font-weight: 300;
    }
  }

  &::placeholder {
    font-size: 14px;
    font-weight: 300;
  }
`;

export const StyledTimePicker = styled(TimePicker)`
  width: 100%;
  font-size: 14px !important;
  font-weight: 300;

  &.ant-picker-large {
    height: 32px;

    input {
      font-size: 14px !important;
      font-weight: 300;
    }
  }

  &::placeholder {
    font-size: 14px;
    font-weight: 300;
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  font-size: 14px;
  font-weight: 300;

  .ant-checkbox + span {
    font-size: 14px;
    font-weight: 300;
  }
`;

export const FormFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 22px;

  &.select-field-container--compact {
    padding-bottom: 0;
  }
`;

export const FormLabel = styled.label`
  font-size: 12px;
  font-weight: 300;
  color: #737777;
  margin-bottom: 4px;
  display: block;
`;

/** Rich label + detail lines inside a Select dropdown option */
export const CustomOption = styled.div`
  display: flex;
  flex-direction: column;

  & > p:first-child {
    font-weight: 500;
    margin-bottom: 0;
  }
  & > p:last-child {
    margin-bottom: 0;
  }
`;

export const SearchTextField = styled.div`
  .ant-input-group-addon {
    padding: 0px 0px;
  }

  .ant-btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    height: 30px !important;
  }
`;
